import { persistUnitDetailContextFromSearch } from 'pages/organizationFlow/organizationUnitDetails/unitDetailBreadcrumb';
import {
  buildUnitDetailSearch,
  DEFAULT_UNIT_DETAIL_TAB,
  parseUnitDetailTabFromSearch,
} from 'pages/organizationFlow/organizationUnitDetails/unitDetailRouting';
import { adminPaths } from 'routes/constants/adminPaths';

import { Navigate, useLocation, useParams } from 'react-router-dom';

/** `/units/:unitId/employees` → canonical unit detail with tab (default employees). */
export const OrganizationUnitEmployeesPathRedirect = () => {
  const { orgName, unitId } = useParams<{ orgName: string; unitId: string }>();
  const { search } = useLocation();

  if (!orgName?.trim() || !unitId?.trim()) {
    return <Navigate to={adminPaths.organizationDashboard} replace />;
  }

  const tab = parseUnitDetailTabFromSearch(search) ?? DEFAULT_UNIT_DETAIL_TAB;
  persistUnitDetailContextFromSearch(search, unitId);

  return (
    <Navigate
      to={{
        pathname: adminPaths.getOrganizationUnitDetailPath(orgName, unitId),
        search: buildUnitDetailSearch(tab),
      }}
      replace
    />
  );
};

/** `/admin/organization/unit?...` → canonical org-scoped unit detail URL. */
export const OrganizationUnitLegacyPathRedirect = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const orgDisplayName = params.get('org')?.trim() ?? '';
  const unitId =
    params.get('unitId')?.trim() ?? params.get('unit_id')?.trim() ?? params.get('id')?.trim() ?? '';

  if (!orgDisplayName || !unitId) {
    return <Navigate to={adminPaths.organizationDashboard} replace />;
  }

  const tab = parseUnitDetailTabFromSearch(search) ?? DEFAULT_UNIT_DETAIL_TAB;
  persistUnitDetailContextFromSearch(search, unitId);

  return (
    <Navigate
      to={{
        pathname: adminPaths.getOrganizationUnitDetailPath(orgDisplayName, unitId),
        search: buildUnitDetailSearch(tab),
      }}
      replace
    />
  );
};
